<template>
  <v-container fluid class="pt-0">
    <v-row no-gutters>
      <v-col cols="12" class="mb-4">
        <v-chip-group
          column
          active-class="accent"
          v-model="range"
        >
          <v-chip
            v-for="range in ranges"
            :key="range.value"
            :value="range.value"
          >{{ range.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="sum in sums"
        :key="sum.key"
        v-if="canSee(sum.path)"
        cols="12" sm="6" md="4" lg="3"
      >
        <home-stats-card
          :key="sum.key"
          :sum="sum.key"
          :color="sum.color"
          :icon="sum.icon"
          :title="sum.title"
          :value="sum.value"
          :path="sum.path"
          :unit="sum.unit"
          :decimal-places="sum.decimal_places"
          :sub-text="sum.version"
          :hidden.sync="sum.hidden"
          sub-icon="mdi-information"
          class="mt-4"
        ></home-stats-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import HomeStatsCard from '../components/home/HomeStatsCard'

  export default {
    name: 'home',
    components: {HomeStatsCard},
    data: () => ({
      interval: null,
      prepared: false,

      sums: [
        {
          key: 'order',
          path: '/home/chart/order',
          unit: '笔',
          title: '运单总数',
          value: 0,
          decimal_places: 0,
          icon: 'mdi-file-document-box',
          color: 'red',
          version: '-',
          hidden: false,
          updated_at: null,
        },
        {
          key: 'order_weight',
          path: '/home/chart/order_weight',
          unit: '吨',
          title: '运输总量',
          value: 0,
          decimal_places: 0,
          icon: 'mdi-package-variant-closed',
          color: 'orange',
          version: '-',
          hidden: false,
          updated_at: null,
        },
        {
          key: 'driver',
          path: '/home/chart/driver',
          unit: '名',
          title: '驾驶员数量',
          value: 0,
          decimal_places: 0,
          icon: 'mdi-steering',
          color: 'green',
          version: '-',
          hidden: false,
          updated_at: null,
        },
        {
          key: 'driver_truck',
          path: '/home/chart/driver_truck',
          unit: '辆',
          title: '车辆数量',
          value: 0,
          decimal_places: 0,
          icon: 'mdi-truck-fast',
          color: 'blue',
          version: '-',
          hidden: false,
          updated_at: null,
        },
        {
          key: 'step_time',
          path: '/home/chart/step_time',
          unit: '小时',
          title: '运力调度时效',
          value: 0,
          decimal_places: 0,
          icon: 'mdi-bus-clock',
          color: 'purple',
          version: '-',
          hidden: false,
          updated_at: null,
        },
        {
          key: 'profit?type=profit',
          path: '/home/chart/profit',
          unit: '元',
          title: '利润',
          value: 0,
          decimal_places: 0,
          icon: 'mdi-cash-multiple',
          color: 'deep-orange',
          version: '-',
          hidden: false,
          updated_at: null,
        },
        {
          key: 'profit?type=profit_rate',
          path: '/home/chart/profit_rate',
          unit: '%',
          title: '利润率',
          value: 0,
          decimal_places: 2,
          icon: 'mdi-sack-percent',
          color: 'teal',
          version: '-',
          hidden: false,
          updated_at: null,
        },
        {
          key: 'petrol_rate',
          path: '/home/chart/petrol_rate',
          unit: '%',
          title: '油占比(承运视角)',
          value: 0,
          decimal_places: 2,
          icon: 'mdi-gas-station',
          color: 'cyan',
          version: '-',
          hidden: false,
          updated_at: null,
        },
        {
          key: 'unit_price?type=client',
          path: '/home/chart/unit_price/client',
          unit: '元·吨',
          title: '承运单价',
          value: 0,
          decimal_places: 2,
          icon: 'mdi-tag',
          color: 'blue-grey',
          version: '-',
          hidden: false,
          updated_at: null,
        },
        {
          key: 'unit_price?type=driver',
          path: '/home/chart/unit_price/driver',
          unit: '元·吨',
          title: '托运单价',
          value: 0,
          decimal_places: 2,
          icon: 'mdi-tag',
          color: 'blue-grey',
          version: '-',
          hidden: false,
          updated_at: null,
        },
        {
          key: 'running_truck',
          path: '/home/chart/running_truck',
          unit: '辆',
          title: '在途车辆',
          value: 0,
          decimal_places: 0,
          icon: 'mdi-map-search',
          color: 'amber',
          version: '-',
          hidden: false,
          updated_at: null,
        },
      ],
      hiddenSums: [],

      range: 'total',
      ranges: [
        {
          text: '统计所有',
          value: 'total',
        },
        {
          text: '统计今年',
          value: 'current_year',
        },
        {
          text: '统计本月',
          value: 'current_month',
        },
        {
          text: '统计本周',
          value: 'current_week',
        },
        {
          text: '统计今天',
          value: 'current_day',
        },
      ]
    }),
    watch: {
      range () {
        this.init()
      }
    },
    methods: {
      init () {
        this.prepared = true
        this.hiddenSums = JSON.parse(localStorage.getItem('hidden_sums') || '[]')

        setInterval(this.refreshSumVersion, 1000)

        localStorage.setItem('sum_range', this.range)

        Promise.race(
          _.map(this.sums, sum => this.getSum(_.get(sum, 'key')))
        )
      },
      getSum (key) {
        return this.$http.post(`/platform/chart/sum/${key}`, {
          range: this.range
        }).then(response => {
          this.sums = _.map(this.sums, sum => Object.assign(sum, _.get(sum, 'key') === key ? {
            value: _.get(response.data, 'data.value'),
            hidden: this.hiddenSums.indexOf(key) > -1,
            updated_at: $moment()
          } : {}))
        }).catch(() => {})
      },

      refreshSumVersion () {
        this.sums = _.map(this.sums, sum => Object.assign(sum, {
          version: $moment(_.get(sum, 'updated_at')).fromNow() + '更新'
        }))
      },
      refreshSumValue (e) {
        const sum = _.find(this.sums, {
          path: _.get(e, 'path')
        })

        if (sum) {
          this.getSum(_.get(sum, 'key'))
        }
      }
    },
    mounted() {
      this.range = localStorage.getItem('sum_range') || 'total'

      this.$bus.$on('refresh', this.refreshSumValue)
      this.$bus.$on('activated', this.init)

      if (this.user) {
        this.$bus.$emit('activated')
      }
    },
    activated() {
      if (this.prepared) {
        this.init()
      }
    }
  }
</script>
